import 'core-js/stable';
import { initSentry } from '@anyroad/sentry';

window.React = require('react');
window.ReactDOM = require('react-dom');

initSentry({ application: 'privacy' });

window.Views = {
  Privacy: require('views/privacy/PrivacyRequest').default,
};
